import { render, staticRenderFns } from "./NinthSection.vue?vue&type=template&id=c9c2d4f0&"
import script from "./NinthSection.vue?vue&type=script&lang=ts&"
export * from "./NinthSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports